// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"38e99698","69":"85ecf7bb","149":"3eaf7347","280":"e4c77ab7","320":"2392ccef","327":"eb455d23","530":"5d46b3a0","979":"75561718"}[chunkId] + ".chunk.js";
};